import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=e09e957e&scoped=true&"
import script from "./Customization.vue?vue&type=script&lang=js&"
export * from "./Customization.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=e09e957e&prod&lang=less&scoped=true&"
import style1 from "./Customization.vue?vue&type=style&index=1&id=e09e957e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09e957e",
  null
  
)

export default component.exports